import { render, staticRenderFns } from "./OrphanFlux.vue?vue&type=template&id=4169f5f0&"
import script from "./OrphanFlux.vue?vue&type=script&lang=js&"
export * from "./OrphanFlux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4169f5f0')) {
      api.createRecord('4169f5f0', component.options)
    } else {
      api.reload('4169f5f0', component.options)
    }
    module.hot.accept("./OrphanFlux.vue?vue&type=template&id=4169f5f0&", function () {
      api.rerender('4169f5f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/OrphanFlux.vue"
export default component.exports